<app-page>
    <app-breadcrumbs [crumbs]="crumbs"></app-breadcrumbs>

    <app-checkpoint-header [checkpoint]="checkpoint()" [platform]="platform()"></app-checkpoint-header>

    @if (checkpointResult(); as r) {
        <app-section [flush]="true" icon="list" layout="stacked" title="Resultaat">
            <app-data-list columns="200px minmax(0, 1fr)" gap="16px">
                <div app-data-row dense>
                    <span class="ui-muted">Platform</span>
                    <span>{{ platform().name }}</span>
                </div>
                <div [class.ui-error]="r.response_status_code === CurlErrorCodesEnum.couldNotResolveHost" app-data-row dense>
                    <span class="ui-muted">Checkpoint</span>
                    <span>{{ checkpoint().name }}</span>
                </div>
                <div app-data-row dense>
                    <span class="ui-muted">Startdatum</span>
                    <span>{{ r.start_date | date: 'EEE d MMM HH:mm:ss' }}</span>
                </div>
                <div app-data-row dense>
                    <span class="ui-muted">Afrondingsdatum</span>
                    <span>{{ (r.finish_date | date: 'EEE d MMM HH:mm:ss') ?? '-' }}</span>
                </div>
                <div [tone]="r.error ? 'error' : null" app-data-row dense>
                    <span class="ui-muted">Status</span>
                    <app-status-dot [tone]="status().tone">{{ status().label }}</app-status-dot>
                </div>
                <div app-data-row dense>
                    <span class="ui-muted">Statuscode</span>
                    <span class="ui-mono">{{ r.response_status_code }}</span>
                </div>
                <div [class.ui-error]="r.result === checksumMismatch" app-data-row dense>
                    <span class="ui-muted">Hash</span>
                    <span class="ui-mono ui-ellipsis">{{ r.hash ?? '-' }}</span>
                </div>
                <div app-data-row dense>
                    <span class="ui-muted">Resultaat</span>
                    <span>{{ r.result }}</span>
                </div>
                <div
                    [class.ui-error]="((r.result === minRespTime || r.result === maxRespTime) && r.error) || r.response_status_code === CurlErrorCodesEnum.timeout"
                    [class.ui-warn]="(r.result === minRespTime || r.result === maxRespTime) && r.warning"
                    app-data-row
                    dense>
                    <span class="ui-muted">Duratie</span>
                    <span class="ui-mono">{{ r.duration ?? 0 }} ms</span>
                </div>
                <div
                    [class.ui-error]="(r.result === minContSize || r.result === maxContSize) && r.error"
                    [class.ui-warn]="(r.result === minContSize || r.result === maxContSize) && r.warning"
                    app-data-row
                    dense>
                    <span class="ui-muted">Grootte</span>
                    <span class="ui-mono">{{ r.size | bytesPipe }}</span>
                </div>
                <div app-data-row dense>
                    <span class="ui-muted">Herhaal poging id</span>
                    <span class="ui-mono">{{ r.retry_id ?? '-' }}</span>
                </div>
                <div app-data-row dense>
                    <span class="ui-muted">Job id</span>
                    <span class="ui-mono">{{ r.job_id }}</span>
                </div>
                <div app-data-row dense>
                    <span class="ui-muted">Aangemaakt op</span>
                    <span>{{ r.created_at | date: 'EEE d MMM HH:mm:ss' }}</span>
                </div>
            </app-data-list>
        </app-section>

        <app-section icon="code" layout="stacked" title="Inhoud">
            @if (r.checkpoint_results_content?.content) {
                <pre class="content">{{ r.checkpoint_results_content?.content | formatResponseText }}</pre>
            } @else {
                <app-empty-state variant="filled">Geen inhoud opgeslagen</app-empty-state>
            }
        </app-section>
    }
</app-page>
